const useKeydown = (callback) => {
  useEffect(() => {
    window.addEventListener("keydown", callback);

    return () => window.removeEventListener("keydown", callback);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useKeydown;
